<template>
  <div class="home-liquor">
    <div
      class="inner"
      @click="$router.push('/liquor/index')"
      @mouseover="play"
      @mouseleave="stop"
      @load="left = -1523"
    >
      <div class="left">
        <img
          src="/liquor/移动长图.png"
          :class="{
              'running': state === 'running',
              'paused': state === 'paused'
          }"
        />
      </div>
      <div class="middle">
        <img src="/liquor/入口icon.png" />
      </div>
      <div class="right">
        <img src="/liquor/入口文案.png" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeLiquor",
  data() {
    return {
      left: 0,
      state: "paused"
    };
  },
  methods: {
    play() {
      this.state = "running";
    },
    stop() {
      this.state = "paused";
    }
  }
};
</script>

<style lang="scss" scoped>
.home-liquor {
  background: rgba(250, 250, 250, 1);
  width: 100%;
  height: 270px;
  margin: 0 auto;
  padding: 60px 0;

  .inner {
    position: relative;
    margin: 0 auto;
    width: 1100px;
    height: 270px;
    cursor: pointer;
  }

  .left {
    position: absolute;
    width: 677px;
    height: 270px;
    overflow: hidden;

    img {
      height: 270px;
    }

    img.running {
      transition: all 15.23s linear;
      transform: translateX(-1523px);
    }

    img.paused {
      animation-play-state: "paused";
      transition: all 1s linear;
    }
  }

  .middle {
    position: absolute;
    width: 138px;
    height: 138px;
    top: 66px;
    right: 353px;
    z-index: 2;
    img {
      width: 138px;
      height: 138px;
    }
  }

  .right {
    position: absolute;
    right: 0;
    width: 423px;
    height: 270px;
    background: linear-gradient(
      315deg,
      rgba(238, 209, 143, 1) 0%,
      rgba(216, 165, 86, 1) 100%
    );
    text-align: center;
    img {
      margin: 50px;
      height: 170px;
    }
  }
}
</style>